/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_SavedInputs */

const en_carrier_notices_saved = /** @type {(inputs: Carrier_Notices_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier notice saved.`)
};

const es_carrier_notices_saved = /** @type {(inputs: Carrier_Notices_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de transportista guardado.`)
};

/**
* | output |
* | --- |
* | "Carrier notice saved." |
*
* @param {Carrier_Notices_SavedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_saved = /** @type {((inputs?: Carrier_Notices_SavedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_SavedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_saved(inputs)
	return es_carrier_notices_saved(inputs)
});